import { AddIcon, MinusIcon } from "@chakra-ui/icons";
import { IconButton } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useIsFormDisabled } from "shared/components/form/FormStateProvider";

export interface TableAddRemoveButtonProps {
  onClick: () => void;
  isDisabled?: boolean;
  alwaysVisible?: boolean;
}

export const TableAddButton: React.FC<TableAddRemoveButtonProps> = ({
  isDisabled,
  alwaysVisible,
  ...props
}) => {
  const { t } = useTranslation(["common"]);
  const isFormDisabled = useIsFormDisabled();
  return (
    <IconButton
      aria-label={t("common:add")}
      icon={<AddIcon color="gray.400" width="10px" height="10px" />}
      isRound={true}
      isDisabled={isFormDisabled || isDisabled}
      data-ls-enabled={true}
      data-public={true}
      size="none"
      sx={{
        minWidth: "24px",
        minHeight: "24px",
        "table &": {
          visibility: alwaysVisible ? "visibile" : "hidden",
        },
        "table tbody tr:last-of-type &, tbody:last-of-type tr:only-child &": {
          visibility: "visible",
        },
      }}
      {...props}
    />
  );
};

export const TableRemoveButton: React.FC<TableAddRemoveButtonProps> = ({
  isDisabled,
  ...props
}) => {
  const { t } = useTranslation(["common"]);
  const isFormDisabled = useIsFormDisabled();
  return (
    <IconButton
      aria-label={t("common:remove")}
      icon={<MinusIcon color="gray.400" width="10px" height="10px" />}
      isRound={true}
      data-ls-enabled={true}
      data-public={true}
      isDisabled={isFormDisabled || isDisabled}
      onMouseDownCapture={(e) => e.stopPropagation()}
      size="none"
      sx={{
        minWidth: "24px",
        minHeight: "24px",
      }}
      {...props}
    />
  );
};
